import { useInfiniteQuery } from '@tanstack/react-query';
import { getInvoicesEmails } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';
import { RESULTS_PER_PAGE } from 'Utils/constants';

export default function useInfiniteInvoicesEmails(filters) {
    return useInfiniteQuery(
        ['invoices', 'emails', filters],
        async ({ pageParam = 1 }) => {
            const response = await getInvoicesEmails({
                ...filters,
                page: pageParam,
            });

            return response;
        },
        {
            refetchOnWindowFocus: false,
            onError: (err) => trackError(err),
            getNextPageParam: (lastPage, allPages) => {
                const pagesLoaded = allPages.length;
                const totalPages = Math.ceil(lastPage.count / RESULTS_PER_PAGE);
                return pagesLoaded < totalPages ? pagesLoaded + 1 : false;
            },
        },
    );
}
